import ScooterNotesModal from './ScooterNotesModal';
export default ScooterNotesModal;
